// store.js
import { create } from "zustand"

const useStore = create((set) => ({
	count: 0,
	increment: () => set((state) => ({ count: state.count + 1 })),
	decrement: () => set((state) => ({ count: state.count - 1 })),
	reset: () => set({ count: 0 }),

	// Pricing Modal State
	pricingModalConfig: {
		title: "Upgrade Needed",
		description: "Upgrade to unlock this feature",
	},
	setPricingModalConfig: (config) => set({ pricingModalConfig: config }),
	openPricingModal: (config) => {
		if (config) {
			set({ pricingModalConfig: config });
		}
		document.getElementById("modal_pricing")?.showModal();
	}
}))

export default useStore
